module.exports = __webpack_public_path__ + "media/pricing/Mosaics-x2-c3f0292c.png";